import configs from 'src/configs.js'
import { TestFrequencies } from 'src/constants.js'

const allFiles = [
  { name: '125', url: '/audio/125Hz.wav' },
  { name: '250', url: '/audio/250Hz.wav' },
  { name: '500', url: '/audio/500Hz.wav' },
  { name: '1000', url: '/audio/1000Hz.wav' },
  { name: '2000', url: '/audio/2000Hz.wav' },
  { name: '4000', url: '/audio/4000Hz.wav' },
  { name: '8000', url: '/audio/8000Hz.wav' },
  { name: 'guitar', url: '/audio/music.mp3' },
]

export default allFiles.filter(
  x => x.name === 'guitar' || TestFrequencies[configs.EXTENT].includes(x.name)
)



// WEBPACK FOOTER //
// ./src/audio/audio-files.js